import {AbstractControl} from '@angular/forms';
import {Directive} from '@angular/core';
import {Input} from '@angular/core';
import {NG_VALIDATORS} from '@angular/forms';
import {OnChanges} from '@angular/core';
import {SimpleChanges} from '@angular/core';
import {Validator} from '@angular/forms';
import {ValidatorFn} from '@angular/forms';
import {Validators} from '@angular/forms';

function isValidEmailLength(email: string): boolean {
    return /^.{1,64}@.{1,253}$/.test(email);
}

function isValidEmailFormat(email: string): boolean {
    return /^(([\w-]+\.)*[\w-]+){1,64}@([\w-]+(\.[\w-]+)*\.[a-zA-Z]{2,6}){1,253}$/.test(email);
}

export function emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const { value } = control;
        if (value) {
            return isValidEmailLength(value) && isValidEmailFormat(value) ? null : { 'email': { value } };
        }
    };
}

@Directive({
    selector: '[emailValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true }]
})
export class EmailValidatorDirective implements Validator, OnChanges {

    private _valFn = Validators.nullValidator;

    @Input()
    emailValidator: string;

    ngOnChanges(changes: SimpleChanges): void {
        this._valFn = changes['emailValidator'] ? emailValidator() : Validators.nullValidator;
    }

    validate(control: AbstractControl): { [key: string]: any } {
        return this._valFn(control);
    }

}